import axios, { AxiosResponse } from "axios";

import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { CustomerTeamCreateUpdateModel, CustomerTeamListModel } from "./model";

const buildApiUrl = (customerId: string) => `/api/customer/${customerId}/teams`;

const getAll = async (customerId: string, abortController: AbortController): Promise<CustomerTeamListModel[]> => {
    const response = await axios.get<ServerModelWithDateStrings<CustomerTeamListModel>[]>(buildApiUrl(customerId), { signal: abortController.signal });
    return response.data;
};

const create = async (customerId: string, customerTeam: CustomerTeamCreateUpdateModel): Promise<CustomerTeamListModel> => {
    const response = await axios.post<
        ServerModelWithDateStrings<CustomerTeamListModel>,
        AxiosResponse<ServerModelWithDateStrings<CustomerTeamListModel>>,
        ServerModelWithDateStrings<CustomerTeamCreateUpdateModel>
    >(buildApiUrl(customerId), customerTeam);
    return response.data;
};

const update = async (customerId: string, teamId: string, customerTeam: CustomerTeamCreateUpdateModel): Promise<CustomerTeamListModel> => {
    const response = await axios.put<
        ServerModelWithDateStrings<CustomerTeamListModel>,
        AxiosResponse<ServerModelWithDateStrings<CustomerTeamListModel>>,
        ServerModelWithDateStrings<CustomerTeamCreateUpdateModel>
    >(`${buildApiUrl(customerId)}/${teamId}`, customerTeam);
    return response.data;
};

export const CustomerTeamApi = { getAll, create, update };
